import makeStyles from '@mui/styles/makeStyles';

const widthModalProps = {
  width: "68vw",
  "@media (max-width: 1000px)": {
    width: "78vw",
  },
  "@media (max-width: 860px)": {
    width: "calc(100vw - 24px)",
  },
  transition: "width .05s ease-in",
};

const styles = makeStyles(() => ({
  container: {
    height: "calc(100vh - 24px)",
    background: "white",
    borderRadius: "8px",
    margin: "12px 12px 12px 0",
    ...widthModalProps,
  },
  header: {
    backgroundColor: "#EDF5FB",
    position: "fixed",
    height: "80px",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    padding: "0px 24px",
    ...widthModalProps,
  },
  title: {
    color: "#308CDB",
    fontWeight: 700,
    fontFamily: "Manrope",
    fontSize: "17px",
  },
  closeContainer: {
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    backgroundColor: "#FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#308CDB",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
  },
  closeIcon: {
    marginTop: "6px",
  },

  content: {
    overflowY: "auto",
    height: "calc(100vh - 104px)",
    marginTop: "80px",
    display: "block",
    "&::-webkit-scrollbar": {
      width: "8px",
      borderBottomRightRadius: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#D1E9FF",
      borderBottomRightRadius: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#84CAFF",
      borderBottomRightRadius: "8px",
    },
  },

  wrapperHeader: {
    background: "#F9FAFB",
    minHeight: "56px",
    padding: "0px 24px",
    marginBottom: "24px",
  },

  wrapperTitle: {
    color: "#465869",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
  },
}));

export default styles;
